import settingsModule from '../../settings.module';

class AccountAuthenticationService {
    constructor(authenticationService, ssoApiService, userApiService) {
        this.authenticationService = authenticationService;
        this.ssoApiService = ssoApiService;
        this.userApiService = userApiService;
    }

    getSpMetadata(accountGuid) {
        return this.ssoApiService.getServiceProviderMetadata(accountGuid);
    }

    getSsoConfiguration() {
        const promise = this.authenticationService
            .getToken()
            .then(cloudToken => {
                return this.ssoApiService.getSsoConfiguration(cloudToken);
            });

        return promise;
    }

    getUserGroups(userGroupNameKeyword, resultLimit, sortCriteria) {
        const promise = this.authenticationService
            .getToken()
            .then(cloudToken => {
                return this.userApiService.getUserGroups(
                    userGroupNameKeyword,
                    resultLimit,
                    sortCriteria,
                    cloudToken
                );
            });

        return promise;
    }

    getUserGroup(userGroupId) {
        const promise = this.authenticationService
            .getToken()
            .then(cloudToken => {
                return this.userApiService.getUserGroup(
                    userGroupId,
                    cloudToken
                );
            });

        return promise;
    }

    saveSsoConfiguration(ssoConfiguration) {
        const promise = this.authenticationService
            .getToken()
            .then(cloudToken => {
                return this.ssoApiService.postSsoConfiguration(
                    cloudToken,
                    ssoConfiguration
                );
            });

        return promise;
    }
}

export default settingsModule.service(
    'accountAuthenticationService',
    AccountAuthenticationService
);



// WEBPACK FOOTER //
// ./modules/settings/services/accountAuthentication/accountAuthentication.service.js